var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _g2, _path12, _g3, _path13, _g4, _path14, _g5, _path15, _g6, _path16, _path17, _g7, _path18, _path19, _g8, _path20, _g9, _path21, _path22, _g10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnthusiaCenterHeaderSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 38,
    viewBox: "0 0 175 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93 37.9213C7.23 37.9213 6.42 37.8513 5.51 37.7213C4.6 37.5913 3.73 37.2913 2.89 36.8213C2.05 36.3513 1.36 35.6413 0.82 34.6813C0.27 33.7313 0 32.4213 0 30.7413V12.5513C0 11.1113 0.22 9.91133 0.66 8.94133C1.1 7.97133 1.69 7.21133 2.42 6.65133C3.15 6.09133 3.96 5.70133 4.84 5.46133C5.72 5.23133 6.59 5.11133 7.44 5.11133C9.64 5.11133 11.59 5.14133 13.28 5.20133C14.97 5.26133 16.49 5.32133 17.84 5.40133C19.19 5.47133 20.42 5.57133 21.54 5.69133V11.1513H9.38C8.47 11.1513 7.77 11.3713 7.27 11.8113C6.77 12.2513 6.52 12.9313 6.52 13.8413V18.5513L19.43 18.9013V24.0513L6.52 24.4013V28.8913C6.52 29.6513 6.64 30.2513 6.89 30.6713C7.14 31.1013 7.48 31.3913 7.9 31.5513C8.33 31.7113 8.77 31.7913 9.24 31.7913H21.53V37.2513C20.24 37.4013 18.81 37.5113 17.24 37.6013C15.67 37.6913 14.08 37.7613 12.48 37.8213C10.88 37.8813 9.37 37.9213 7.93 37.9213Z",
    fill: "#134046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9883 37.7004V14.0504H31.3583L32.5083 16.4704C33.3883 15.7404 34.4983 15.0804 35.8383 14.5104C37.1783 13.9404 38.5483 13.6504 39.9583 13.6504C41.8983 13.6504 43.3983 14.0304 44.4483 14.7904C45.5083 15.5504 46.2483 16.5704 46.6683 17.8504C47.0983 19.1304 47.3083 20.5504 47.3083 22.1004V37.7004H40.7883V22.9404C40.7883 22.1804 40.6483 21.5504 40.3683 21.0504C40.0883 20.5504 39.6983 20.1704 39.1983 19.9104C38.6983 19.6504 38.0983 19.5104 37.3883 19.5104C36.7683 19.5104 36.1783 19.5804 35.6083 19.7304C35.0383 19.8804 34.4883 20.0804 33.9783 20.3504C33.4683 20.6104 32.9683 20.9204 32.4983 21.2804V37.7004H25.9883Z",
    fill: "#134046"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1819 37.7016C59.3619 37.7016 57.8819 37.4416 56.7519 36.9116C55.6219 36.3816 54.8019 35.5016 54.3119 34.2716C53.8119 33.0416 53.5919 31.3816 53.6519 29.2916L53.8719 19.2916H50.1719V15.1016L54.0919 14.0416L54.9719 7.43164H60.1219V14.0416H65.6719V19.2816H60.1219V29.2316C60.1219 29.8816 60.1819 30.4116 60.3019 30.8216C60.4219 31.2316 60.5919 31.5616 60.8119 31.8116C61.0319 32.0616 61.2919 32.2416 61.5819 32.3616C61.8719 32.4816 62.1719 32.5516 62.4619 32.5816L65.4619 32.8416V37.6816H61.1819V37.7016Z",
    fill: "#134046"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3281 37.7006V4.14062H75.8481V16.4706C76.6981 15.7706 77.8081 15.1206 79.1781 14.5306C80.5481 13.9406 81.9481 13.6506 83.3881 13.6506C85.1781 13.6506 86.6081 14.0006 87.6581 14.7106C88.7181 15.4106 89.4781 16.4006 89.9481 17.6606C90.4181 18.9206 90.6481 20.3906 90.6481 22.0606V37.7006H84.1281V22.9006C84.1281 22.1406 83.9781 21.5106 83.6881 21.0106C83.3981 20.5106 82.9981 20.1406 82.4981 19.8906C81.9981 19.6406 81.4081 19.5206 80.7381 19.5206C80.1181 19.5206 79.5281 19.6006 78.9581 19.7606C78.3881 19.9206 77.8381 20.1306 77.3281 20.4006C76.8181 20.6606 76.3181 20.9606 75.8481 21.2806V37.7006H69.3281Z",
    fill: "#134046"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.231 37.9608C100.121 37.9608 98.4614 37.3408 97.2514 36.0908C96.0514 34.8408 95.4414 33.0708 95.4414 30.7808V14.0508H101.961V28.8508C101.961 30.1708 102.281 31.0608 102.911 31.5108C103.541 31.9708 104.371 32.1908 105.401 32.1908C106.221 32.1908 107.071 32.0408 107.931 31.7308C108.801 31.4208 109.571 31.0008 110.241 30.4808V14.0508H116.801V37.7008H111.381L110.231 35.2808C109.171 35.9808 107.951 36.6108 106.571 37.1508C105.211 37.6908 103.751 37.9608 102.231 37.9608Z",
    fill: "#134046"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.33 37.9603C129.6 37.9603 128.8 37.9403 127.95 37.8903C127.1 37.8503 126.25 37.7803 125.4 37.6903C124.55 37.6003 123.76 37.4903 123.02 37.3603C122.29 37.2303 121.67 37.0703 121.17 36.9003V33.0703H131.65C132.27 33.0703 132.77 33.0203 133.17 32.9203C133.57 32.8203 133.86 32.6303 134.05 32.3503C134.24 32.0703 134.34 31.6703 134.34 31.1403V30.3903C134.34 29.8003 134.15 29.3503 133.77 29.0203C133.39 28.6903 132.68 28.5403 131.66 28.5403H127.96C126.61 28.5403 125.39 28.3303 124.3 27.9203C123.21 27.5103 122.35 26.8303 121.72 25.8903C121.09 24.9503 120.77 23.6903 120.77 22.1003V20.7303C120.77 19.2303 121.06 17.9703 121.65 16.9403C122.24 15.9103 123.22 15.1303 124.6 14.6103C125.98 14.0803 127.87 13.8203 130.28 13.8203C131.25 13.8203 132.28 13.8703 133.39 13.9703C134.49 14.0703 135.53 14.2103 136.52 14.3703C137.5 14.5303 138.29 14.7203 138.88 14.9203V18.7503H128.97C128.12 18.7503 127.47 18.8903 127.03 19.1703C126.59 19.4503 126.37 19.9703 126.37 20.7303V21.4303C126.37 21.9603 126.47 22.3503 126.68 22.6003C126.89 22.8503 127.2 23.0303 127.63 23.1303C128.06 23.2303 128.59 23.2803 129.24 23.2803H133.03C135.44 23.2803 137.19 23.8303 138.29 24.9303C139.39 26.0303 139.94 27.5503 139.94 29.4903V31.6003C139.94 33.1903 139.57 34.4403 138.82 35.3703C138.07 36.3003 136.98 36.9603 135.56 37.3503C134.12 37.7703 132.38 37.9603 130.33 37.9603Z",
    fill: "#134046"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 14.0508H143.98V37.7008H150.5V14.0508Z",
    fill: "#134046"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.542 37.9607C158.752 37.9607 157.292 37.4307 156.182 36.3807C155.062 35.3207 154.512 33.8507 154.512 31.9707V29.8607C154.512 28.0707 155.142 26.5907 156.402 25.4307C157.662 24.2707 159.632 23.6907 162.302 23.6907H168.332V22.0607C168.332 21.3307 168.202 20.7207 167.932 20.2307C167.672 19.7507 167.172 19.3907 166.452 19.1707C165.732 18.9507 164.642 18.8407 163.172 18.8407H156.082V15.0507C157.232 14.7007 158.552 14.3907 160.072 14.1207C161.582 13.8607 163.412 13.7207 165.552 13.7207C167.522 13.7207 169.202 13.9607 170.592 14.4207C171.982 14.8907 173.042 15.7007 173.762 16.8407C174.482 17.9907 174.842 19.5707 174.842 21.6007V37.7007H169.692L168.632 35.1907C168.422 35.4307 168.072 35.6907 167.572 35.9807C167.072 36.2707 166.462 36.5707 165.742 36.8807C165.022 37.1907 164.212 37.4507 163.322 37.6507C162.442 37.8607 161.512 37.9607 160.542 37.9607ZM163.842 33.4307C164.132 33.4307 164.462 33.3907 164.832 33.3207C165.202 33.2507 165.582 33.1607 165.982 33.0607C166.382 32.9607 166.742 32.8607 167.082 32.7507C167.422 32.6507 167.702 32.5507 167.922 32.4607C168.142 32.3707 168.282 32.3107 168.342 32.2807V26.7707L164.382 27.0307C163.232 27.1207 162.392 27.4107 161.852 27.9107C161.312 28.4107 161.032 29.0907 161.032 29.9407V30.9107C161.032 31.5007 161.152 31.9807 161.402 32.3607C161.652 32.7407 161.992 33.0107 162.412 33.1807C162.842 33.3507 163.322 33.4307 163.842 33.4307Z",
    fill: "#134046"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.148 11.4707C150.186 11.4707 152.648 9.00827 152.648 5.9707C152.648 2.93314 150.186 0.470703 147.148 0.470703C144.111 0.470703 141.648 2.93314 141.648 5.9707C141.648 9.00827 144.111 11.4707 147.148 11.4707Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2668_22664)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.707 6.02039C152.707 9.12039 150.207 11.6404 147.127 11.6404C144.047 11.6404 141.547 9.12039 141.547 6.02039C141.547 2.92039 144.047 0.400391 147.127 0.400391C150.207 0.400391 152.707 2.92039 152.707 6.02039ZM151.547 4.28039C151.427 2.53039 149.697 1.25039 149.067 0.940391C148.617 0.720391 148.207 0.600391 148.207 0.600391C148.117 0.580391 147.687 0.480391 147.137 0.490391C146.587 0.480391 146.197 0.600391 146.107 0.620391C146.107 0.620391 145.627 0.770391 145.177 0.990391C144.547 1.30039 142.847 2.53039 142.717 4.28039C142.637 5.45039 143.157 6.56039 144.847 8.20039C145.917 9.25039 147.017 10.0504 147.137 10.6304V10.6404V10.6304C147.247 10.0504 148.347 9.25039 149.427 8.20039C151.097 6.56039 151.627 5.45039 151.547 4.28039Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.667 0.400391H147.117V11.4804H152.667V0.400391Z",
    fill: "#009E74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.707 6.02039C152.707 9.12039 150.207 11.6404 147.127 11.6404C144.047 11.6404 141.547 9.12039 141.547 6.02039C141.547 2.92039 144.047 0.400391 147.127 0.400391C150.207 0.400391 152.707 2.92039 152.707 6.02039ZM151.547 4.28039C151.427 2.53039 149.697 1.25039 149.067 0.940391C148.617 0.720391 148.207 0.600391 148.207 0.600391C148.117 0.580391 147.687 0.480391 147.137 0.490391C146.587 0.480391 146.197 0.600391 146.107 0.620391C146.107 0.620391 145.627 0.770391 145.177 0.990391C144.547 1.30039 142.847 2.53039 142.717 4.28039C142.637 5.45039 143.157 6.56039 144.847 8.20039C145.917 9.25039 147.017 10.0504 147.137 10.6304V10.6404V10.6304C147.247 10.0504 148.347 9.25039 149.427 8.20039C151.097 6.56039 151.627 5.45039 151.547 4.28039Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.146 0.400391H141.586V11.4804H147.146V0.400391Z",
    fill: "#E84296"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.707 6.02039C152.707 9.12039 150.207 11.6404 147.127 11.6404C144.047 11.6404 141.547 9.12039 141.547 6.02039C141.547 2.92039 144.047 0.400391 147.127 0.400391C150.207 0.400391 152.707 2.92039 152.707 6.02039ZM151.547 4.28039C151.427 2.53039 149.697 1.25039 149.067 0.940391C148.617 0.720391 148.207 0.600391 148.207 0.600391C148.117 0.580391 147.687 0.480391 147.137 0.490391C146.587 0.480391 146.197 0.600391 146.107 0.620391C146.107 0.620391 145.627 0.770391 145.177 0.990391C144.547 1.30039 142.847 2.53039 142.717 4.28039C142.637 5.45039 143.157 6.56039 144.847 8.20039C145.917 9.25039 147.017 10.0504 147.137 10.6304V10.6404V10.6304C147.247 10.0504 148.347 9.25039 149.427 8.20039C151.097 6.56039 151.627 5.45039 151.547 4.28039Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.137 -1V8.59C150.007 8.58 152.327 6.44 152.327 3.79C152.327 1.14 150.007 -0.99 147.137 -1Z",
    fill: "#008054"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.707 6.02039C152.707 9.12039 150.207 11.6404 147.127 11.6404C144.047 11.6404 141.547 9.12039 141.547 6.02039C141.547 2.92039 144.047 0.400391 147.127 0.400391C150.207 0.400391 152.707 2.92039 152.707 6.02039ZM151.547 4.28039C151.427 2.53039 149.697 1.25039 149.067 0.940391C148.617 0.720391 148.207 0.600391 148.207 0.600391C148.117 0.580391 147.687 0.480391 147.137 0.490391C146.587 0.480391 146.197 0.600391 146.107 0.620391C146.107 0.620391 145.627 0.770391 145.177 0.990391C144.547 1.30039 142.847 2.53039 142.717 4.28039C142.637 5.45039 143.157 6.56039 144.847 8.20039C145.917 9.25039 147.017 10.0504 147.137 10.6304V10.6404V10.6304C147.247 10.0504 148.347 9.25039 149.427 8.20039C151.097 6.56039 151.627 5.45039 151.547 4.28039Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.106 -1C144.236 -0.99 141.906 1.15 141.906 3.8C141.906 6.45 144.236 8.59 147.106 8.6V-1Z",
    fill: "#DB2977"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.707 6.02039C152.707 9.12039 150.207 11.6404 147.127 11.6404C144.047 11.6404 141.547 9.12039 141.547 6.02039C141.547 2.92039 144.047 0.400391 147.127 0.400391C150.207 0.400391 152.707 2.92039 152.707 6.02039ZM151.547 4.28039C151.427 2.53039 149.697 1.25039 149.067 0.940391C148.617 0.720391 148.207 0.600391 148.207 0.600391C148.117 0.580391 147.687 0.480391 147.137 0.490391C146.587 0.480391 146.197 0.600391 146.107 0.620391C146.107 0.620391 145.627 0.770391 145.177 0.990391C144.547 1.30039 142.847 2.53039 142.717 4.28039C142.637 5.45039 143.157 6.56039 144.847 8.20039C145.917 9.25039 147.017 10.0504 147.137 10.6304V10.6404V10.6304C147.247 10.0504 148.347 9.25039 149.427 8.20039C151.097 6.56039 151.627 5.45039 151.547 4.28039Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703ZM149.257 7.4007C148.297 8.3407 147.257 9.0507 147.157 9.5707C147.057 9.0507 146.117 8.3307 145.147 7.4007C143.637 5.9307 143.157 4.9407 143.237 3.9007C143.347 2.3407 144.877 1.2707 145.447 0.990703C145.847 0.790703 146.267 0.690703 146.267 0.690703C146.347 0.670703 146.707 0.590703 147.207 0.600703C147.697 0.590703 148.067 0.670703 148.147 0.690703C148.147 0.690703 148.567 0.790703 148.967 0.990703C149.537 1.2707 151.067 2.3407 151.177 3.9007C151.237 4.9407 150.767 5.9307 149.257 7.4007Z",
    fill: "#29AAE1"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.148 11.4707C150.186 11.4707 152.648 9.00827 152.648 5.9707C152.648 2.93314 150.186 0.470703 147.148 0.470703C144.111 0.470703 141.648 2.93314 141.648 5.9707C141.648 9.00827 144.111 11.4707 147.148 11.4707Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703ZM149.257 7.4007C148.297 8.3407 147.257 9.0507 147.157 9.5707C147.057 9.0507 146.117 8.3307 145.147 7.4007C143.637 5.9307 143.157 4.9407 143.237 3.9007C143.347 2.3407 144.877 1.2707 145.447 0.990703C145.847 0.790703 146.267 0.690703 146.267 0.690703C146.347 0.670703 146.707 0.590703 147.207 0.600703C147.697 0.590703 148.067 0.670703 148.147 0.690703C148.147 0.690703 148.567 0.790703 148.967 0.990703C149.537 1.2707 151.067 2.3407 151.177 3.9007C151.237 4.9407 150.767 5.9307 149.257 7.4007Z",
    fill: "#29AAE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 0,
    width: 12,
    height: 12
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.148 11.4707C150.186 11.4707 152.648 9.00827 152.648 5.9707C152.648 2.93314 150.186 0.470703 147.148 0.470703C144.111 0.470703 141.648 2.93314 141.648 5.9707C141.648 9.00827 144.111 11.4707 147.148 11.4707Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2668_22664)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 0,
    width: 11,
    height: 12
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.398 10.6903C143.318 9.92031 143.268 8.77031 143.608 7.62031C143.998 6.31031 144.988 5.13031 145.838 3.97031C146.618 2.90031 147.158 2.00031 147.158 1.32031C147.158 2.00031 147.688 2.83031 148.488 3.91031C149.088 4.71031 149.838 5.57031 150.338 6.45031C150.728 7.15031 150.928 7.96031 150.858 8.77031C150.798 9.53031 150.488 10.2503 149.788 10.7703C149.488 10.9803 148.908 11.2703 148.268 11.3803C147.988 11.4303 147.408 11.5303 147.188 11.5303C147.058 11.5303 146.328 11.4503 145.838 11.3103C145.348 11.1903 144.818 11.0203 144.398 10.6903Z",
    fill: "url(#paint0_linear_2668_22664)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 0,
    width: 11,
    height: 12
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2668_22664)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 1,
    width: 8,
    height: 11
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.398 10.6903C143.318 9.92031 143.268 8.77031 143.608 7.62031C143.998 6.31031 144.988 5.13031 145.838 3.97031C146.618 2.90031 147.158 2.00031 147.158 1.32031C147.158 2.00031 147.688 2.83031 148.488 3.91031C149.088 4.71031 149.838 5.57031 150.338 6.45031C150.728 7.15031 150.928 7.96031 150.858 8.77031C150.798 9.53031 150.488 10.2503 149.788 10.7703C149.488 10.9803 148.908 11.2703 148.268 11.3803C147.988 11.4303 147.408 11.5303 147.188 11.5303C147.058 11.5303 146.328 11.4503 145.838 11.3103C145.348 11.1903 144.818 11.0203 144.398 10.6903Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703ZM149.257 7.4007C148.297 8.3407 147.257 9.0507 147.157 9.5707C147.057 9.0507 146.117 8.3307 145.147 7.4007C143.637 5.9307 143.157 4.9407 143.237 3.9007C143.347 2.3407 144.877 1.2707 145.447 0.990703C145.847 0.790703 146.267 0.690703 146.267 0.690703C146.347 0.670703 146.707 0.590703 147.207 0.600703C147.697 0.590703 148.067 0.670703 148.147 0.690703C148.147 0.690703 148.567 0.790703 148.967 0.990703C149.537 1.2707 151.067 2.3407 151.177 3.9007C151.237 4.9407 150.767 5.9307 149.257 7.4007Z",
    fill: "#1889AF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 0,
    width: 11,
    height: 12
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.555 11.0499C144.935 10.2799 144.905 9.12992 145.095 7.97992C145.315 6.66992 145.895 5.48992 146.385 4.31992C146.835 3.24992 147.145 2.34992 147.145 1.66992C147.145 2.34992 147.445 3.17992 147.915 4.25992C148.265 5.05992 148.695 5.91992 148.985 6.79992C149.215 7.49992 149.325 8.30992 149.285 9.11992C149.255 9.87992 149.075 10.5999 148.665 11.1199C148.495 11.3299 148.155 11.6199 147.785 11.7299C147.625 11.7799 147.285 11.8799 147.155 11.8799C147.075 11.8799 146.655 11.7999 146.375 11.6599C146.105 11.5399 145.795 11.3699 145.555 11.0499Z",
    fill: "url(#paint1_linear_2668_22664)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 0,
    width: 11,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2668_22664)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2668_22664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 0,
    width: 11,
    height: 12
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 0.470703C144.497 0.470703 142.317 2.9507 142.297 6.0107C142.287 9.0707 144.447 11.5507 147.127 11.5507C149.807 11.5507 151.987 9.0707 152.007 6.0107C152.017 2.9507 149.857 0.470703 147.177 0.470703ZM149.257 7.4007C148.297 8.3407 147.257 9.0507 147.157 9.5707C147.057 9.0507 146.117 8.3307 145.147 7.4007C143.637 5.9307 143.157 4.9407 143.237 3.9007C143.347 2.3407 144.877 1.2707 145.447 0.990703C145.847 0.790703 146.267 0.690703 146.267 0.690703C146.347 0.670703 146.707 0.590703 147.207 0.600703C147.697 0.590703 148.067 0.670703 148.147 0.690703C148.147 0.690703 148.567 0.790703 148.967 0.990703C149.537 1.2707 151.067 2.3407 151.177 3.9007C151.237 4.9407 150.767 5.9307 149.257 7.4007Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2668_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.555 11.0499C144.935 10.2799 144.905 9.12992 145.095 7.97992C145.315 6.66992 145.895 5.48992 146.385 4.31992C146.835 3.24992 147.145 2.34992 147.145 1.66992C147.145 2.34992 147.445 3.17992 147.915 4.25992C148.265 5.05992 148.695 5.91992 148.985 6.79992C149.215 7.49992 149.325 8.30992 149.285 9.11992C149.255 9.87992 149.075 10.5999 148.665 11.1199C148.495 11.3299 148.155 11.6199 147.785 11.7299C147.625 11.7799 147.285 11.8799 147.155 11.8799C147.075 11.8799 146.655 11.7999 146.375 11.6599C146.105 11.5399 145.795 11.3699 145.555 11.0499Z",
    fill: "url(#paint2_linear_2668_22664)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2668_22664",
    x1: 147.144,
    y1: -2.34309,
    x2: 147.144,
    y2: 20.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#F49FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#7FD9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#FCD091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A89B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2668_22664",
    x1: 147.143,
    y1: 1.67512,
    x2: 147.143,
    y2: 11.8893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D72A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D72A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6E4E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2C7170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06936D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2668_22664",
    x1: 147.143,
    y1: 1.67512,
    x2: 147.143,
    y2: 11.8893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D72A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D72A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D72A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#074C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#036350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnthusiaCenterHeaderSvg);
export default __webpack_public_path__ + "static/media/EnthusiaCenterHeaderSvg.f56fbe35077864892fbdd95161e51b90.svg";
export { ForwardRef as ReactComponent };